import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicCheckbox = () => {
  const [state, setState] = useState({
    gilad: true,
    jason: false,
    antoine: false,
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const { gilad, jason, antoine } = state;
  const error = [gilad, jason, antoine].filter((v) => v).length !== 2;

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic checkboxes
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"            <Checkbox defaultChecked />\n" +
              "            <Checkbox />\n" +
              "            <Checkbox disabled />\n" +
              "            <Checkbox disabled checked />"}>
            <Checkbox defaultChecked />
            <Checkbox />
            <Checkbox disabled />
            <Checkbox disabled checked />
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"}>
            Label
          </Typography>
          <Typography variant="body1" mb={1}>
            You can provide a label to the Checkbox thanks to the
            FormControlLabel component.
          </Typography>

          <PreviewAndEditor language={"js"} value={"            <FormGroup>\n" +
              "              <FormControlLabel\n" +
              "                control={<Checkbox defaultChecked />}\n" +
              "                label=\"Label\"\n" +
              "              />\n" +
              "              <FormControlLabel\n" +
              "                required\n" +
              "                control={<Checkbox />}\n" +
              "                label=\"Required\"\n" +
              "              />\n" +
              "              <FormControlLabel\n" +
              "                disabled\n" +
              "                control={<Checkbox />}\n" +
              "                label=\"Disabled\"\n" +
              "              />\n" +
              "            </FormGroup>"}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Label"
              />
              <FormControlLabel
                required
                control={<Checkbox />}
                label="Required"
              />
              <FormControlLabel
                disabled
                control={<Checkbox />}
                label="Disabled"
              />
            </FormGroup>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"}>
            Size
          </Typography>

          <Typography variant="body1" mb={1}>
            Use the size prop or customize the font size of the svg icons to
            change the size of the checkboxes.
          </Typography>

          <PreviewAndEditor  language={"js"} value={"            <Checkbox defaultChecked size=\"small\" />\n" +
              "            <Checkbox defaultChecked />\n" +
              "            <Checkbox defaultChecked size=\"large\" />"}>
            <Checkbox defaultChecked size="small" />
            <Checkbox defaultChecked />
            <Checkbox defaultChecked size="large" />
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"}>
            Color
          </Typography>

          <PreviewAndEditor language={"js"} value={"            <Checkbox defaultChecked />\n" +
              "            <Checkbox defaultChecked color=\"primary\" />\n" +
              "            <Checkbox defaultChecked color=\"secondary\" />\n" +
              "            <Checkbox defaultChecked color=\"error\" />\n" +
              "            <Checkbox defaultChecked color=\"warning\" />\n" +
              "            <Checkbox defaultChecked color=\"info\" />\n" +
              "            <Checkbox defaultChecked color=\"success\" />"}>
            <Checkbox defaultChecked />
            <Checkbox defaultChecked color="primary" />
            <Checkbox defaultChecked color="secondary" />
            <Checkbox defaultChecked color="error" />
            <Checkbox defaultChecked color="warning" />
            <Checkbox defaultChecked color="info" />
            <Checkbox defaultChecked color="success" />
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"}>
            Form Group Check Box
          </Typography>

          <PreviewAndEditor  language={"js"} value={"            <FormControl sx={{ m: 3 }} component=\"fieldset\" variant=\"standard\">\n" +
              "              <FormLabel component=\"legend\">Assign responsibility</FormLabel>\n" +
              "              <FormGroup>\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={gilad}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"gilad\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Gilad Gray\"\n" +
              "                />\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={jason}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"jason\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Jason Killian\"\n" +
              "                />\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={antoine}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"antoine\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Antoine Llorca\"\n" +
              "                />\n" +
              "              </FormGroup>\n" +
              "              <FormHelperText>Be careful</FormHelperText>\n" +
              "            </FormControl>\n" +
              "            <FormControl\n" +
              "              required\n" +
              "              error={error}\n" +
              "              component=\"fieldset\"\n" +
              "              sx={{ m: 3 }}\n" +
              "              variant=\"standard\"\n" +
              "            >\n" +
              "              <FormLabel component=\"legend\">Pick two</FormLabel>\n" +
              "              <FormGroup>\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={gilad}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"gilad\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Gilad Gray\"\n" +
              "                />\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={jason}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"jason\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Jason Killian\"\n" +
              "                />\n" +
              "                <FormControlLabel\n" +
              "                  control={\n" +
              "                    <Checkbox\n" +
              "                      checked={antoine}\n" +
              "                      onChange={handleChange}\n" +
              "                      name=\"antoine\"\n" +
              "                    />\n" +
              "                  }\n" +
              "                  label=\"Antoine Llorca\"\n" +
              "                />\n" +
              "              </FormGroup>\n" +
              "              <FormHelperText>You can display an error</FormHelperText>\n" +
              "            </FormControl>"}>
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormLabel component="legend">Assign responsibility</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={gilad}
                      onChange={handleChange}
                      name="gilad"
                    />
                  }
                  label="Gilad Gray"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={jason}
                      onChange={handleChange}
                      name="jason"
                    />
                  }
                  label="Jason Killian"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={antoine}
                      onChange={handleChange}
                      name="antoine"
                    />
                  }
                  label="Antoine Llorca"
                />
              </FormGroup>
              <FormHelperText>Be careful</FormHelperText>
            </FormControl>
            <FormControl
              required
              error={error}
              component="fieldset"
              sx={{ m: 3 }}
              variant="standard"
            >
              <FormLabel component="legend">Pick two</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={gilad}
                      onChange={handleChange}
                      name="gilad"
                    />
                  }
                  label="Gilad Gray"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={jason}
                      onChange={handleChange}
                      name="jason"
                    />
                  }
                  label="Jason Killian"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={antoine}
                      onChange={handleChange}
                      name="antoine"
                    />
                  }
                  label="Antoine Llorca"
                />
              </FormGroup>
              <FormHelperText>You can display an error</FormHelperText>
            </FormControl>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicCheckbox;
